import React from 'react'
import style from './loading.module.scss'
import { Logo } from '../../components/logo/Logo'
import { VegaLoading } from '../../components/vega/loading/Loading'
import { VegaHeading } from '../../components/vega/heading/Heading'
import VegaColors from '../../resources/constants/colors.module.scss'

export const Loading = () => {
	return (
		<div className={style.loading}>
			<div className={style.logo}>
				<Logo height={34} />
			</div>
			<VegaLoading size={60} color={VegaColors.SECONDARYINVERTED} />
			<VegaHeading className={style.title} tag={'h5'} label={'Loading experience...'} />
		</div>
	)
}
